// extracted by mini-css-extract-plugin
export default {"news":"News_news__5XsSz","itemNews":"News_itemNews__vPn7P","nameNews":"News_nameNews__CFlGo","dateNews":"News_dateNews__tCkxj","descrNews":"News_descrNews__pj-Fe"};